import React, { useEffect, useState } from "react";
import {
  Button,
  TextInput,
  Paper,
  Title,
  Text,
  Container,
  Group,
  PasswordInput,
  Stack,
  Divider,
} from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { settingsServices } from "../../services/settingsServices";
import { register } from "../../services/authServices";
import useAuthStore from "../../store/useAuthStore";
import Notebook from "./Notebook";

const Profile = () => {
  const { user } = useAuthStore();
  const [settings, setSettings] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [isPinging, setIsPinging] = useState(false);

  // Admin user creation state
  const [newUsername, setNewUsername] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [isCreatingUser, setIsCreatingUser] = useState(false);

  const getSettings = async () => {
    try {
      const response = await settingsServices.getSettings();
      setSettings(response.user.alarmerToken);
    } catch (error) {
      console.log("Error getting settings:", error);
    }
  };

  const saveSettings = async () => {
    setIsSaving(true);
    try {
      await settingsServices.saveSettings(settings);
      notifications.show({
        title: "Успіх",
        message: "Налаштування збережено успішно!",
        color: "green",
      });
    } catch (error) {
      console.log("Error saving settings:", error);
      notifications.show({
        title: "Помилка",
        message: "Помилка при збереженні налаштувань!",
        color: "red",
      });
    } finally {
      setIsSaving(false);
    }
  };

  const handlePing = async () => {
    setIsPinging(true);
    try {
      const res = await settingsServices.pingBot();
      notifications.show({
        title: "Алармер",
        message: res.message || "Тестовий пінг відправлено!",
        color: "blue",
      });
    } catch (error) {
      notifications.show({
        title: "Помилка",
        message:
          error.response?.data?.message ||
          "Не вдалося відправити пінг. Перевірте токен.",
        color: "red",
      });
    } finally {
      setIsPinging(false);
    }
  };

  const handleCreateUser = async (e) => {
    e.preventDefault();
    if (!newUsername || !newPassword) {
      return notifications.show({
        title: "Помилка",
        message: "Заповніть всі поля",
        color: "red",
      });
    }
    
    setIsCreatingUser(true);
    try {
      await register(newUsername, newPassword);
      notifications.show({
        title: "Успіх",
        message: "Користувача створено",
        color: "green",
      });
      setNewUsername("");
      setNewPassword("");
    } catch (error) {
      notifications.show({
        title: "Помилка",
        message: error.message || "Помилка при створенні користувача",
        color: "red",
      });
    } finally {
      setIsCreatingUser(false);
    }
  };

  useEffect(() => {
    getSettings();
  }, []);

  return (
    <Container size="xl" p={0}>
      <div className="workspace-heading"><div><Title order={2}>Profile Settings</Title><Text c="dimmed" mt={5}>Manage your workspace preferences and personal notes.</Text></div></div>
      <Paper withBorder shadow="sm" p="md" radius="md">
        <TextInput
          label="Alarmer API-KEY tg: @alarmer_bot"
          description="Enter your Alarmer bot API key"
          value={settings}
          onChange={(event) => setSettings(event.currentTarget.value)}
          placeholder="api-key"
          mb="md"
        />
        {user?.isAdmin && (
          <TextInput
            label="Your Profit Share (%)"
            value={user?.profitPercentage || 0}
            readOnly
            description="This is your custom profit percentage set by admin"
            mb="md"
          />
        )}
        <Group>
          <Button onClick={saveSettings} loading={isSaving}>
            Зберегти
          </Button>
          <Button
            variant="light"
            color="blue"
            onClick={handlePing}
            loading={isPinging}
            disabled={!settings}
          >
            Ping Bot
          </Button>
        </Group>
      </Paper>

      {user?.isAdmin && (
        <>
          <Divider my="xl" />
          <Title order={3} mb="lg">
            Admin - Create New User
          </Title>
          <Paper withBorder shadow="sm" p="md" radius="md">
            <form onSubmit={handleCreateUser}>
              <Stack>
                <TextInput
                  label="Username"
                  placeholder="Enter username"
                  value={newUsername}
                  onChange={(e) => setNewUsername(e.currentTarget.value)}
                  required
                />
                <PasswordInput
                  label="Password"
                  placeholder="Enter password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.currentTarget.value)}
                  required
                />
                <Button type="submit" loading={isCreatingUser} w="fit-content">
                  Create User
                </Button>
              </Stack>
            </form>
          </Paper>
        </>
      )}

      <Notebook />
    </Container>
  );
};

export default Profile;
